import React, { useState } from 'react';

function LoginModal({ open, onClose, onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username || !password) {
      setError('Username and password required');
      return;
    }
    const ok = await onLogin(username, password);
    if (!ok) setError('Invalid credentials');
  };

  if (!open) return null;
  return (
    <div className="modal-overlay">
      <form onSubmit={handleSubmit} className="modal-content">
        <h3 style={{ marginTop: 0 }}>Login</h3>
        <div style={{ marginBottom: 16 }}>
          <input 
            type="text" 
            placeholder="Username" 
            value={username} 
            onChange={e => setUsername(e.target.value)} 
            className="input"
            style={{ width: '100%', marginBottom: 8 }} 
          />
          <input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
            className="input"
            style={{ width: '100%' }} 
          />
        </div>
        {error && <div style={{ color: 'var(--danger)', marginBottom: 12 }}>{error}</div>}
        <div className="modal-actions">
          <button type="button" onClick={onClose} className="btn btn-secondary">Cancel</button>
          <button type="submit" className="btn btn-primary">Login</button>
        </div>
      </form>
    </div>
  );
}

export default LoginModal;
